<template>
  <HelloWorld/>

</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  components: {

    HelloWorld
  }
}
</script>
<style lang="scss">

</style>